import { loginCompany, loginOrg } from '@/utils/LoginContext';
import request from '@/utils/request';
import { stringify } from 'qs';

export async function save(payload) {
  return request(`/iwms-wms/wms/order`, {
    method: 'POST',
    body: payload,
  });
}

export async function saveAndAudit(payload) {
  return request(`/iwms-wms/wms/order/saveAndAudit`, {
    method: 'POST',
    body: payload,
  });
}

export async function deleteOrder(payload) {
  return request(`/iwms-wms/wms/order/${payload.uuid}?version=${payload.version}`, {
    method: 'DELETE',
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/order/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload) {
  return request(`/iwms-wms/wms/order/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function abort(payload) {
  return request(`/iwms-wms/wms/order/abort/${payload.uuid}?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/order/audit/${payload.uuid}?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function batchImport(payload) {
  return request(`/iwms-wms/wms/order/batchimport?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&fileKey=${payload.fileKey}`, {
    method: 'POST'
  });
}
// export async function getImportTemplateUrl() {
//   return request(`/iwms-wms/wms/order/templet/download`);
// }

export async function book(payload) {
  return request(`/iwms-wms/wms/order/book/${payload.uuid}?version=${payload.version}&bookedQtyStr=${payload.bookedQtyStr}&bookedArticleCount=${payload.bookedArticleCount}&bookTime=${payload.bookTime}`, { method: 'POST' });
}

export async function finish(payload) {
  return request(`/iwms-wms/wms/order/finish/${payload.uuid}?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function finishByBillNumbers(payload) {
  return request(`/iwms-wms/wms/order/finishByBillNumbers/?dcUuid=${loginOrg().uuid}`, {
    method: 'POST',
    body: payload.billNumbers,
  });
}

export async function dailyFinish(payload) {
  return request(`/iwms-wms/wms/order/dailyFinish/${payload.uuid}?version=${payload.version}`, {
    method: 'POST'
  });
}

export async function finishByReceivable(payload) {
  return request(`/iwms-wms/wms/order/finishByReceivable?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'POST'
  });
}
export async function finishByConfirm(payload) {
  return request(`/iwms-wms/wms/order/finishByConfirm?billNumber=${payload.billNumber}&dcUuid=${loginOrg().uuid}`, {
    method: 'POST'
  });
}

export async function receive(payload) {
  return request(`/iwms-wms/wms/order/receive/?billNumber=${payload.billNumber}&dcUuid=${payload.dcUuid}&articleUuid=${payload.articleUuid}&qpcStr=${payload.qpcStr}&qty=${payload.qty}&version=${payload.version}`, {
    method: 'POST'
  });
}

export async function get(uuid) {
  return request(`/iwms-wms/wms/order/${uuid}`);
}

export async function getBySourceBillNumberAndDcUuid(payload) {
  return request(`/iwms-wms/wms/order/getByBillNumber?billNumber=${payload.sourceBillNumber}&dcUuid=${payload.dcUuid}`);
}

export async function copy(payload) {
  return request(`/iwms-wms/wms/order/copy?${stringify(payload)}`, {
    method: 'POST'
  });
}

export async function pricing(payload) {
  return request(`/iwms-wms/wms/order/pricing?billUuid=${payload.billUuid}&version=${payload.version}`, {
    method: 'POST',
    body: payload.data,
  });
}

export async function queryByBillNumbers(payload) {
  return request(`/iwms-wms/wms/order/queryByBillNumbers?dcUuid=${payload.dcUuid}`, {
    method: 'POST',
    body: payload.billNumbers,
  });
}

export async function queryNoAutoFinishBill(payload) {
  return request(`/iwms-wms/wms/order/queryNoAutoFinishBill?billNumber=${payload.billNumber}&dcUuid=${payload.dcUuid}&type=${payload.type}`, {
    method: 'GET'
  });
}

export async function reject(payload) {
  return request(`/iwms-wms/wms/order/reject?dcUuid=${payload.dcUuid}&billNumber=${payload.billNumber}`, {
    method: 'POST',
    body: payload,
  });
}

export async function orderReject(payload) {
  return request(`/iwms-wms/wms/order/orderReject?dcUuid=${payload.dcUuid}&orderBillNumber=${payload.billNumber}`, {
    method: 'POST',
    body: payload.items,
  });
}

export async function uploadAttachment(payload) {
  return request(`/iwms-wms/wms/order/uploadAttachment`, {
    method: 'POST',
    body: payload,
  });
}

export async function getAttachment(payload) {
  return request(`/iwms-wms/wms/order/getAttachment?orderBillUuid=${payload.orderBillUuid}`, {
    method: 'POST',
  });
}

export async function deleteAttachment(payload) {
  return request(`/iwms-wms/wms/order/deleteAttachment?fKey=${payload.fkey}&orderBillUuid=${payload.orderBillUuid}`, {
    method: 'DELETE',
  });
}

export async function verifyPrice(payload) {
  return request(`/iwms-wms/wms/order/verifyPrice`, {
    method: 'POST',
    body: payload.uuids,
  })
}

export async function modifyFee(payload) {
  if (payload.vehicleModel && payload.feeNote) {
      return request(`/iwms-wms/wms/order/modifyFee?billUuid=${payload.billUuid}&stevedorage=${payload.stevedorage}&vehicleModel=${payload.vehicleModel}&feeNote=${payload.feeNote}&version=${payload.version}`, {
        method: 'POST',
    });
  } else if (payload.vehicleModel && !payload.feeNote) {
      return request(`/iwms-wms/wms/order/modifyFee?billUuid=${payload.billUuid}&stevedorage=${payload.stevedorage}&vehicleModel=${payload.vehicleModel}&version=${payload.version}`, {
        method: 'POST',
    });
  } else if (!payload.vehicleModel && payload.feeNote) {
      return request(`/iwms-wms/wms/order/modifyFee?billUuid=${payload.billUuid}&stevedorage=${payload.stevedorage}&feeNote=${payload.feeNote}&version=${payload.version}`, {
        method: 'POST',
    });
  } else {
    return request(`/iwms-wms/wms/order/modifyFee?billUuid=${payload.billUuid}&stevedorage=${payload.stevedorage}&version=${payload.version}`, {
      method: 'POST',
  });
  }


}
